module.exports = __webpack_public_path__ + "img/CK.686313cc.png";